import { useParams } from 'react-router-dom';
import Translator from '../Translator';

export const Machine = () => {
    const params = useParams();

    return (
     <>
        <Translator defaultMachine={params.slug} />
     </>
    );
};

export default Machine;